import { useRouter as useNextRouter, Router } from 'next/router'

type Url = Parameters<Router['push']>[0]

const getNextNetworkPathname = (url: Url, network: string): Url => {
  let nextPathname: Url
  if (typeof url === 'string') {
    nextPathname = `/n/${network}${url}`
  } else {
    nextPathname = {
      ...url,
      pathname: `/n/${network}${url.pathname}`
    }
  }

  return nextPathname
}

export const useRouter = () => {
  const router = useNextRouter()
  const {
    query: { network }
  } = router

  const networkPush: Router['push'] = (url, as, options) => {
    const nextPathname = network
      ? getNextNetworkPathname(url, network as string)
      : url

    return router.push(nextPathname, as, options)
  }

  const networkReplace: Router['replace'] = (url, as, options) => {
    const nextPathname = network
      ? getNextNetworkPathname(url, network as string)
      : url

    return router.replace(nextPathname, as, options)
  }

  return {
    ...router,
    networkPush,
    networkReplace
  }
}
